import { axios } from '@/lib/axios';

export type ProjectSlotFilters = {
  name?: string;
  sector?: string;
  minPrice?: string;
  maxPrice?: string;
};

export const getProjectSlots = async (filters?: ProjectSlotFilters) => {
  const cleanParams = filters
    ? Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== '' && v != null),
      )
    : undefined;
  const response = await axios.get('/project-slots', { params: cleanParams });
  return response.data;
};

export const addProjectSlot = async (data: FormData) => {
  const resp = await axios.post('/project-slots', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return resp.data;
};

export const purchaseSlot = async (data: { id: string; quantity: number }) => {
  const resp = await axios.post(`/project-slots/purchase/${data.id}`, {
    quantity: Number(data.quantity),
  });
  return resp.data;
};

export const deleteProjectSlot = async (id: string) => {
  const resp = await axios.delete(`/project-slots/${id}`);
  return resp.data;
};

export const updateProjectSlot = async (data: {
  id: string;
  [key: string]: any;
}) => {
  const { id, ...body } = data;
  const resp = await axios.patch(`/project-slots/${id}`, body);
  return resp.data;
};

export const completeProjectSlot = async (id: string) => {
  const resp = await axios.patch(`/project-slots/complete/${id}`);
  return resp.data;
};

export const getAvailableProjectSlots = async (
  filters?: ProjectSlotFilters,
) => {
  const cleanParams = filters
    ? Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== '' && v != null),
      )
    : undefined;
  const response = await axios.get('/project-slots/market/available', {
    params: cleanParams,
  });
  return response.data;
};
